import { render, staticRenderFns } from "./KimsaGridTable.vue?vue&type=template&id=e654904e&scoped=true"
import script from "./KimsaGridTable.vue?vue&type=script&lang=js"
export * from "./KimsaGridTable.vue?vue&type=script&lang=js"
import style0 from "./KimsaGridTable.vue?vue&type=style&index=0&id=e654904e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e654904e",
  null
  
)

export default component.exports